<template>
  <!-- 权限管理-行为日志 -->
  <div class="action_log-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-select v-model="query.name" placeholder="请选择用户账号" @change="getData(1)">
            <el-option
              v-for="item in accountList"
              :key="item.id"
              :value="item.name"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.nickname"
            placeholder="请输入用户备注"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.remark"
            placeholder="请输入用户行为模糊搜索"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 200px"
            v-model="query.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          ——
          <el-date-picker
            style="width: 200px"
            v-model="query.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="created_at" label="时间" align="center">
        </el-table-column>
        <el-table-column prop="name" label="用户账号" align="center">
        </el-table-column>
        <el-table-column prop="nickname" label="用户备注" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="用户行为说明" align="center">
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="350px">
          <template slot-scope="{ row }">
            <el-button type="primary" @click="openNoteDialog(row)"
              >编辑备注</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页 -->
      <el-pagination
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 编辑备注弹窗 -->
    <EditNoteDialog
      :visible="editNoteVisible"
      v-model="dialogInfo"
      @close="editNoteVisible = false"
      @refresh="getData"
    ></EditNoteDialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import EditNoteDialog from '@/components/permission/EditNoteDialog.vue'

export default {
  components: {
    EditNoteDialog
  },
  data() {
    return {
      editNoteVisible: false,//编辑备注弹窗显示标志
      loading: false,//加载动画
      query: {
        page: 1,
        name: '',
        nickname: '',
        remark: ''
      },
      dialogInfo: undefined,//弹窗传递数据
      dataList: undefined, //数据列表
      accountList: undefined,//账户列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
    this.getAccount()
  },
  methods: {
    getData(num) {
      //获取列表数据
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('admin_log', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getAccount() {
      //获取所有账户信息
      getApiData('admin_list').then(res => {
        if (res) {
          this.accountList = res
        }
      }).finally(() => {
      })
    },
    openNoteDialog(rowInfo) {
      //打开添加备注弹窗
      this.editNoteVisible = true
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.action_log-box {
  header {
  }

  .body-box {
  }
}
</style>